import { Action } from "@ngrx/store";

import { Pharmacy } from "@intocare/medication/medication-data";

export const SET_PHARMACIES = "[Pharmacy] Set pharmacies";
export const ADD_PHARMACY = "[Pharmacy] Add pharmacy";
export const UPDATE_PHARMACY = "[Pharmacy] Update pharmacy";

export const LOADING_PHARMACIES = "[Pharmacy] Loading pharmacies";
export const LOADED_PHARMACIES = "[Pharmacy] Loaded pharmacies";

export class SetPharmacies implements Action {
	readonly type = SET_PHARMACIES;

	payload: {
		data: Pharmacy[];
	};

	constructor(data: Pharmacy[]) {
		this.payload = {
			data,
		};
	}
}

export class AddPharmacy implements Action {
	readonly type = ADD_PHARMACY;

	payload: {
		data: Pharmacy;
	};

	constructor(data: Pharmacy) {
		this.payload = {
			data,
		};
	}
}

export class UpdatePharmacy implements Action {
	readonly type = UPDATE_PHARMACY;

	payload: {
		data: Pharmacy;
	};

	constructor(data: Pharmacy) {
		this.payload = {
			data,
		};
	}
}

export class LoadingPharmacies implements Action {
	readonly type = LOADING_PHARMACIES;
}

export type Actions = SetPharmacies | UpdatePharmacy | AddPharmacy | LoadingPharmacies;
